import vue from 'vue'

const state = {
  uniqueValues: {},
  tableLoading: false,
  uniqueValuesUpdated: false
}

const mutations = {
  SET_UNIQUE_VALUES (state, values) {
    vue.set(state, 'uniqueValues', values)
  },
  SET_UNIQUE_VALUES_UPDATED (state, value) {
    state.uniqueValuesUpdated = value
  },
  SET_EXP_TABLE_LOADING (state, value) {
    state.tableLoading = value
  }
}

export default {
  state,
  mutations
}
